<template>
  <div>
    <h4>Четверти</h4>
    <list :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink" :cardLink="cardLink" :isUpdate="true"
      :isAdd="true" :itemLink="itemLink" :setLink="setLink" :openItem="false" :fields="fields" :searchDisable="true"
      @change="change" @changeFunction="changeFunction" v-model="val" />
  </div>

</template>
<script>
export default {
  name: "products",
  props: ['id'],
  created() {
    this.itemLink = `business/seasons/${this.id}/parts`;
    this.setLink = `business/seasons/${this.id}/parts`;
  },
  methods: {
    changeFunction(val) { },
    change(val) { },

  },
  data() {
    return {
      val: [],
      modalCreate: "client_group",
      fields: [
        {
          label: "Четверть",
          key: "position",
          type: "static_radio",
          items: [
            { id: '1', title: "I четверть" },
            { id: '2', title: "II четверть" },
            { id: '3', title: "III четверть" },
            { id: '4', title: "IV четверть" },
          ],
        },
        {
          col: 'col-12 col-md-6',
          key: "from_at",
          label: "Начало четверти",
          type: "field",
          textType: "date",
          readonly: false,
          dateFormat: true,
        },
        {
          col: 'col-12 col-md-6',
          key: "till_at",
          label: "Окончание четверти",
          type: "field",
          textType: "date",
          readonly: false,
          dateFormat: true,
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_part",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "position",
          title: "Номер четверти",
          checkbox: false,
        },
        {
          dateFormat: true,
          key: "from_at",
          title: "С",
          // disableLink: true,
        },
        {
          dateFormat: true,
          key: "till_at",
          title: "По",
          // disableLink: true,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
